import * as React from "react";
import { CssBaseline } from "@mui/material";

export default function Introduction() {
  return (
    <React.Fragment>
      <CssBaseline />
      <div className="intro">
        <h2>
          <a>
            {" 简介 "}
            <small>Introduction</small>
          </a>
        </h2>
        <p className="introContent">
          实时预测（Nowcasting）作为一种面向当前和近期未来的预测技术，
          能够通过高频数据反映经济活动的动态，为政府决策和学术研究提供科学支持。
          近年来，信息技术和大数据的快速发展为经济预测提供了新的可能性。
          北大汇丰智库·宏观经济实时预测平台旨在利用高频数据、先进的计算工具与前沿的计量经济学和机器学习方法，
          预测中国、广东省及深圳市的宏观经济指标，
          提供对经济现状的及时估计与短期趋势预测。
          <br />
          <br />
          北大汇丰智库·宏观经济实时预测平台的目标是在官方数据发布之前，
          基于大数据进行模型预测，对当前经济活动精确追踪，提供对经济现状的前瞻性洞察。
          本平台采用了多种前沿的计量模型和机器学习算法，包括动态因子模型（Dynamic
          Factor Model）、循环神经网络（Recurrent Neural Networks）等。
          通过整合计量模型和机器学习技术，北大汇丰研究团队不仅显著提升了经济预测的精度，
          还提供了应对本地经济波动的有效工具。特别是对于深圳市等外向型经济体，
          平台能够捕捉全球经济风险对本地经济的传导效应，为政策制定者提供精准、实时的经济信息支持。
        </p>
      </div>
    </React.Fragment>
  );
}
